import React, { useRef, useEffect } from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import { Flex, Text } from 'rebass/styled-components';

import useTranslation from 'hooks/use-translation';
import { Typography } from 'src/typography';

import { Image } from 'shared/components';

function ConvenienceFeeModal({ onClose, open }) {
  const buttonRef = useRef();
  const { t } = useTranslation();

  // direct focus to close button on open
  useEffect(() => {
    if (buttonRef.current) {
      buttonRef.current.focus();
    }
  }, [open]);

  return (
    <FeeModal flexWrap='wrap' open={open}>
      <CloseButton ref={buttonRef} onClick={onClose}>
        <Image src='/icons/x-grey.svg' alt='Close' width='11px' />
      </CloseButton>
      <div>
        <Text fontSize={16} fontWeight='bold' color='#43474a' mb='17px'>
          {t('feeCopy.fees', 'Fees')}
        </Text>
        <Typography.Body size='medium'>
          {t('feeCopy.message', 'This is a fee associated with the convenience of ordering via website.')}
        </Typography.Body>
      </div>
    </FeeModal>
  );
}

export default observer(ConvenienceFeeModal);

const FeeModal = styled(({ ...props }) => <Flex {...props} />)`
  position: absolute;
  width: calc(100% - 43px);
  top: 100px;
  left: 21px;
  padding: 20px;
  border-radius: 7px;
  background-color: white;
  z-index: 2;
  box-shadow: 0 2px 5px 1px rgba(0, 0, 0, 0.06);
  opacity: ${(props) => (props.open ? '1' : '0')};
  visibility: ${(props) => (props.open ? `visible` : `hidden`)};
  transition: opacity 0.2s;
`;

const CloseButton = styled.button`
  appearance: none;
  border: none;
  padding: 0;
  background-color: transparent;
  position: absolute;
  top: 18px;
  right: 18px;
  cursor: pointer;
`;
